import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function JourneyCard({ journey, index = 0 }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 1, delay: index * 0.05, ease: [0.19, 1, 0.22, 1] }}
      data-testid={`journey-card-${journey.slug}`}
      className="group relative"
    >
      <Link to={`/journeys/${journey.slug}`} className="block">
        <div className="relative aspect-[4/5] img-frame">
          <img src={journey.thumb} alt={journey.name} loading="lazy" />
          <div className="absolute inset-0 flex flex-col justify-between p-6 md:p-8 z-10">
            <div className="flex items-center justify-between">
              <span className="mono text-[10px] uppercase tracking-[0.28em] text-[color:var(--ivory)]">
                {journey.country}
              </span>
              <span className="mono text-[10px] uppercase tracking-[0.28em] text-[color:var(--ivory)]">
                {journey.duration}
              </span>
            </div>
            <div>
              {journey.signature && (
                <span
                  className="inline-block mb-3 mono text-[10px] uppercase tracking-[0.28em] px-3 py-1.5 border"
                  style={{ borderColor: "var(--gold)", color: "var(--gold-3)" }}
                >
                  2026 Signature
                </span>
              )}
              <h3 className="font-display text-3xl md:text-4xl leading-none text-[color:var(--ivory)]">
                {journey.name}
              </h3>
            </div>
          </div>
        </div>

        <div className="pt-5 flex items-start justify-between gap-4">
          <p className="max-w-md text-[15px] leading-relaxed text-[color:var(--ink)]/80 font-italic-display text-lg">
            {journey.tagline}
          </p>
          <span
            className="mt-1 inline-flex h-9 w-9 items-center justify-center rounded-full border transition-all duration-500 group-hover:bg-[color:var(--gold)] group-hover:border-[color:var(--gold)]"
            style={{ borderColor: "var(--ink)" }}
          >
            <ArrowUpRight size={16} strokeWidth={1.4} className="transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </span>
        </div>
      </Link>
    </motion.article>
  );
}
